import React from 'react';
import { cn } from '../../utils/cn';
import {
  USAGE_STATUS,
  formatSeatsUsage,
  getUsagePercent,
  getUsageStatus,
} from '../../utils/usage';

const BAR_COLORS = {
  [USAGE_STATUS.EMPTY]: 'bg-gray-300',
  [USAGE_STATUS.NORMAL]: 'bg-primary-500',
  [USAGE_STATUS.FULL]: 'bg-success-500',
  [USAGE_STATUS.EXCEEDED]: 'bg-danger-500',
};

export const UsageBar = ({ seats, installed, className, showLabel = true }) => {
  const status = getUsageStatus(seats, installed);
  const percent = getUsagePercent(seats, installed);

  return (
    <div
      className={cn('flex items-center gap-2 min-w-[140px]', className)}
      title={`${installed} instalaciones realizadas de ${seats} licencias contratadas (${percent}%)`}
    >
      <div className="h-2 flex-1 rounded-full bg-gray-100 overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-all', BAR_COLORS[status])}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-xs font-medium text-gray-700 whitespace-nowrap tabular-nums">
          {formatSeatsUsage(seats, installed)}
        </span>
      )}
    </div>
  );
};
